import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PermissionService } from './permission.service';
import { IfRoleDirective } from './if-role.directive';
import { RoleClassDirective } from './role-class.directive';

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  declarations: [
    IfRoleDirective,
    RoleClassDirective
  ],
  exports: [
    IfRoleDirective,
    RoleClassDirective
  ]
})
export class PermissionModule {

  public static forRoot(): ModuleWithProviders {
    return {
        ngModule: PermissionModule,
        providers: [
          PermissionService
        ]
      };
  }

  public static forChild(): ModuleWithProviders {
    return {
        ngModule: PermissionModule
      };
  }

}



// WEBPACK FOOTER //
// /dist/src/app/security/permission/permission.module.ts